export const environment = {
  baseUrl: 'https://smartwallet.mic-ksa.com',
  production: true,
  version: '1.0.3',
  encryption: {
    saltB64: '',
    iterations: 200000,
  },
  firebase: {
    // Use the same Firebase project as development
    apiKey: 'AIzaSyC7S2g4XCt2IflULreTB0GlUNQC68XLECg',
    authDomain: 'smart-wallet-5a765.firebaseapp.com',
    projectId: 'smart-wallet-5a765',
    storageBucket: 'smart-wallet-5a765.firebasestorage.app',
    messagingSenderId: '596944214360',
    appId: '1:596944214360:web:2a9d93cfac7928a409ad2d',
    measurementId: 'G-E83Y2DP67Y',
  },
};
